import axios from "../axios";

/**
 * 材料推优保存
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const save = (data) => {
  return axios({
    url: "/mKwry/save",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

/**
 * 列表查询
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const findPage = (data) => {
  return axios({
    url: '/mKwry/list',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

/**
 * 校验身份证重复
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const checkIdNumber = (data) => {
  return axios({
    url: '/mKwry/checkIdNumber',
    method: 'post',
    data
  })

}

/**
 * 校验编号
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const checkNumber = (data) => {
  return axios({
    url: '/mKwry/checkNumber',
    method: 'post',
    data
  })

}

export const del = (data) => {
  return axios({
    url: '/mKwry/delete',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}

//下载模板

export const download = (data) => {
  return axios({
    url: '/mKwry/download',
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, data.name)
    }
  })
}

export const exportKwry = (data, name) => {
  return axios({
    url: '/mKwry/export',
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data,
    responseType: 'blob'
  }).then(res => {
    console.log(res)
    if (res) {
      openDownloadDialog(res, name)
    }
  })
}

let openDownloadDialog = function (blob, fileName) {
  if (window.navigator.msSaveOrOpenBlob) {
    navigator.msSaveBlob(blob, fileName);
  } else {
    const elink = document.createElement('a')
    elink.download = fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  }
}

export const queryKwry = (data) => {
  return axios({
    url: "/mKwry/queryKwry",
    headers: {'Content-Type': 'application/json'},
    noSerializeData: true,//不序列化参数
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/kwry.js